import { Dispatch } from 'redux';
import { Services } from '../../types/services';

const FETCH_ROLES_REQUEST = 'FETCH_ROLES_REQUEST';
const GET_ROLES = 'GET_ROLES';
const ROLES_ERROR = 'ROLES_ERROR';

interface Role {
  id: number;
  name: string;
}

interface State {
  roles: Role[];
  loading: boolean;
  error: string;
}

const initialState: State = {
  roles: [],
  loading: false,
  error: '',
};

interface Action {
  type: typeof FETCH_ROLES_REQUEST | typeof GET_ROLES | typeof ROLES_ERROR;
  payload?: Role[] | string;
}

export const reducer = (state = initialState, action: Action) => {
  switch (action.type) {
    case FETCH_ROLES_REQUEST:
      return {
        ...state,
        loading: true,
        error: '',
      };
    case GET_ROLES:
      return {
        ...state,
        roles: action.payload,
        loading: false,
        error: '',
      };
    case ROLES_ERROR:
      return {
        ...state,
        roles: [],
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export const actions = (services: Services) => {
  const axiosService = services.axios.Axios();

  const fetchRoles = () => {
    return async (dispatch: Dispatch) => {
      try {
        dispatch({ type: FETCH_ROLES_REQUEST });
        const response = await axiosService.get<Role[]>('roles');
        dispatch({ type: GET_ROLES, payload: response.data });
      } catch (error: unknown) {
        const errorMsg = error instanceof Error ? error.message : 'An unknown error occurred';
        dispatch({ type: ROLES_ERROR, payload: errorMsg });
      }
    };
  };

  return {
    fetchRoles,
  };
};
